import { render } from "./FAQ1.vue?vue&type=template&id=11d6fc4e"
import script from "./FAQ1.vue?vue&type=script&lang=js"
export * from "./FAQ1.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__